import { mapGetters } from 'vuex';
import RegExp from '@/utils/regExp.js';

export default {
  data() {
    return {
      idTypeList: [],
      form: {
        legalName: '',
        legalMobile: '',
        legalIdType: '1',
        legalIdCard: ''
      },
      rules: {
        legalName: [
          { required: true, message: '请输入法定代表人姓名', trigger: 'blur'}
        ],
        legalIdType: [
          { required: true, message: '请选择法定代表人证件类型', trigger: 'change'}
        ],
        legalIdCard: [
          { required: true, message: '请输入法定代表人证件号', trigger: 'blur'},
          { pattern: RegExp.idCard, message: '请输入正确的法定代表人证件号', trigger: 'blur'}
        ],
        legalMobile: [
          { required: true, message: '请输入法定代表人手机号码', trigger: 'blur'},
          { pattern: RegExp.phone, message: '请输入正确的法定代表人手机号码', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.$store.commit('SET_COMPANY_LEGAL_INFO', {});
    // 获取证件类型列表
    this.getIdTypeList();
  },
  computed: {
    ...mapGetters([
      'userType'
    ])
  },
  methods: {
    // 存储表单
    storeForm() {
      this.$store.commit('SET_COMPANY_LEGAL_INFO', this.form);
      this.$emit('storeForm');
    },
    // 获取字典：证件类型列表
    getIdTypeList() {
      this.$store.dispatch('getSelectDictList', 'ID_TYPE').then(res => {
        if (res.code === '0') {
          this.idTypeList = res.data;
        }
      });
    },
    validateForm() {
      let isValid = false;
      this.$refs['form'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    }
  }

};
